"use client";
import React from "react";
import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { useNavigate } from "react-router-dom";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const SignatureSection = () => {
  const navigate = useNavigate();

  const handleProductClick = () => {
    navigate("/menu");
  };

  const products = [
    {
      id: 1,
      name: "Gulab Jamun",
      price: "$ 55",
      image: "https://api.builder.io/api/v1/image/assets/TEMP/5c2ee34ced63a3a1955d42fd05b32ee1c915b0c7?placeholderIfAbsent=true&apiKey=d09e0bc02eef4ced83b05308e83d6101"
    },
    {
      id: 2,
      name: "Butterscotch cake",
      price: "$ 55",
      image: "https://api.builder.io/api/v1/image/assets/TEMP/031df95065592585dcc6f325b1daf787dbd5a5ea?placeholderIfAbsent=true&apiKey=d09e0bc02eef4ced83b05308e83d6101"
    },
    {
      id: 3,
      name: "Blueberry cake",
      price: "$ 50",
      image: "https://api.builder.io/api/v1/image/assets/TEMP/ad852224650ff8582f0129007c0faac403cbf3cc?placeholderIfAbsent=true&apiKey=d09e0bc02eef4ced83b05308e83d6101"
    }
  ];

  return (
    <motion.section
      className="flex overflow-hidden flex-col items-center w-full bg-rose-200 bg-opacity-50"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true }}
      aria-labelledby="signature-title"
    >
      {/* Section Divider - To change colors, modify the SVG fill and stroke properties in the image URL */}
      <motion.img
        src="https://api.builder.io/api/v1/image/assets/TEMP/bca50df9c6c131b18e6c13e934c23427c496b7e3?placeholderIfAbsent=true&apiKey=d09e0bc02eef4ced83b05308e83d6101"
        alt="Decorative border element"
        className="object-cover w-full h-auto  md:max-h-auto lg:max-h-auto"
        initial={{ y: 50, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.6, delay: 0.2 }}
        viewport={{ once: true }}
      />

      <div className="flex flex-col items-center pr-2 sm:pr-4 md:pr-11 pb-11 mt-14 max-w-full w-full max-w-4xl mx-auto px-2 sm:px-4 max-md:mt-10">
        <motion.h2
          id="signature-title"
          className="text-4xl md:text-6xl font-semibold text-cyan-900 text-center"
          style={{ fontFamily: "'Sansita Swashed', cursive" }}
          initial={{ scale: 0.8, opacity: 0 }}
          whileInView={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          viewport={{ once: true }}
        >
          Our Signature
        </motion.h2>

        <motion.div
          className="flex gap-4 md:gap-6 items-center mt-6 md:mt-9 justify-center"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.6 }}
          viewport={{ once: true }}
        >
          <img
            src="https://api.builder.io/api/v1/image/assets/TEMP/a004749eeafe96650e9f1ab184dc488f2a5d7166?placeholderIfAbsent=true&apiKey=d09e0bc02eef4ced83b05308e83d6101"
            alt="Decorative line left"
            className="object-contain shrink-0 self-stretch my-auto aspect-[166.67] w-[120px] md:w-[171px]"
          />
          <img
            src="https://api.builder.io/api/v1/image/assets/TEMP/0601124a7204e4ec8863e3301f81f2dc160b4313?placeholderIfAbsent=true&apiKey=d09e0bc02eef4ced83b05308e83d6101"
            alt="Decorative center element"
            className="object-contain shrink-0 self-stretch my-auto aspect-square w-[25px] md:w-[35px]"
          />
          <img
            src="https://api.builder.io/api/v1/image/assets/TEMP/42135f6d9b1a4837d8746dac7416759042e4672d?placeholderIfAbsent=true&apiKey=d09e0bc02eef4ced83b05308e83d6101"
            alt="Decorative line right"
            className="object-contain shrink-0 self-stretch my-auto aspect-[166.67] w-[120px] md:w-[172px]"
          />
        </motion.div>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.8 }}
          viewport={{ once: true }}
        >
          Indulge in our signature baked goods—freshly crafted with love,
          using the finest ingredients to bring you the perfect taste in
          every bite.
        </motion.p>

        <motion.div
          className="w-full mt-14 max-md:mt-10"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 1.0 }}
          viewport={{ once: true }}
        >
          <div className="flex items-center justify-center">
            <div className="hidden lg:flex justify-center items-start my-auto text-sm font-black leading-4 text-center text-cyan-900 whitespace-nowrap min-h-[70px] mr-8">
              <div className="text-sm font-black leading-4" aria-hidden="true"></div>
            </div>

            <div className="w-full pt-2.5 max-w-[1600px] px-1 sm:px-2">
              <Swiper
                modules={[Navigation, Pagination, Autoplay]}
                spaceBetween={8}
                slidesPerView={1}
                navigation={{
                  prevEl: '.signature-prev',
                  nextEl: '.signature-next',
                }}
                pagination={{
                  clickable: true,
                  el: '.signature-pagination'
                }}
                autoplay={{ delay: 3000, disableOnInteraction: false }}
                breakpoints={{
                  320: { slidesPerView: 1, spaceBetween: 6 },
                  370: { slidesPerView: 1, spaceBetween: 10 },
                  480: { slidesPerView: 1, spaceBetween: 15 },
                  640: { slidesPerView: 1, spaceBetween: 20 },
                  768: { slidesPerView: 2, spaceBetween: 25 },
                  1024: { slidesPerView: 2, spaceBetween: 30 },
                  1280: { slidesPerView: 3, spaceBetween: 40 },
                  1440: { slidesPerView: 3, spaceBetween: 50 },
                  1600: { slidesPerView: 3, spaceBetween: 60 },
                  1920: { slidesPerView: 3, spaceBetween: 80 },
                  2560: { slidesPerView: 3, spaceBetween: 100 }
                }}
                loop={true}
                className="signature-swiper"
                style={{
                  paddingLeft: '4px',
                  paddingRight: '4px'
                }}
              >
                {products.map((product, index) => (
                  <SwiperSlide key={product.id} className="pt-4 px-1 sm:px-2 md:px-3">
                    <motion.article
                      className="flex overflow-hidden flex-col pb-8 md:pb-14 bg-white rounded-3xl border-4 border-solid border-slate-500 w-full mx-auto h-auto"
                      style={{
                        minWidth: typeof window !== 'undefined' && window.innerWidth < 370 ? '280px' : '300px',
                        maxWidth: '1500px',
                        transitionDelay: `${index * 0.1}s`
                      }}
                      whileHover={{ scale: 1.02, y: -5 }}
                      transition={{ duration: 0.3 }}
                      initial={{ opacity: 0, y: 50 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: true }}
                    >
                      <div className="flex relative flex-col items-start px-3 pt-3 pb-40 md:pb-48 lg:pb-56 xl:pb-64 2xl:pb-72 w-full text-sm leading-loose text-white whitespace-nowrap">
                        <img
                          src={product.image}
                          alt={product.name}
                          onClick={handleProductClick}
                          className="object-cover absolute inset-0 size-full rounded-t-2xl cursor-pointer hover:opacity-90 transition-opacity duration-300"
                        />
                        <div className="flex relative flex-col justify-center items-center px-2.5 mb-0 w-12 h-12 md:w-14 md:h-14 bg-red-500 rounded-3xl text-xs md:text-sm">
                          <span>SALE</span>
                        </div>
                      </div>
                      <div className="flex gap-3 md:gap-5 justify-between items-center self-center mt-6 md:mt-8 px-4 w-full">
                        <h3
                          className="text-xl md:text-2xl leading-tight text-cyan-900 flex-1"
                          style={{ fontFamily: "'Foolish Talk', cursive" }}
                        >
                          {product.name}
                        </h3>
                        <span className="text-2xl md:text-3xl font-semibold text-red-500 whitespace-nowrap">
                          {product.price}
                        </span>
                      </div>
                    </motion.article>
                  </SwiperSlide>
                ))}
              </Swiper>

              {/* Custom Navigation Buttons */}
              {/* <button className="signature-prev absolute left-4 top-1/2 transform  z-10 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center text-cyan-900 hover:text-red-500 transition-colors duration-300 lg:left-0">
                <span className="text-2xl font-bold">‹</span>
              </button>

              <button className="signature-next absolute right-4 top-1/2 transform  z-10 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center text-cyan-900 hover:text-red-500 transition-colors duration-300 lg:right-0">
                <span className="text-2xl font-bold">›</span>
              </button> */}

              {/* Custom Pagination */}
              <div className="signature-pagination flex justify-center mt-8 space-x-2"></div>
            </div>

            <div className="hidden lg:flex justify-center items-start my-auto text-sm font-black leading-4 text-center text-cyan-900 whitespace-nowrap min-h-[70px] rotate-[3.141592653589793rad] ml-8">
              <div className="text-sm font-black leading-4" aria-hidden="true"></div>
            </div>
          </div>
        </motion.div>
      </div>

      {/* Section Divider - To change colors, modify the SVG fill and stroke properties in the image URL */}
      <motion.img
        src="https://api.builder.io/api/v1/image/assets/TEMP/3ffc05ec4acfc0339d48c800c9d9a76598715819?placeholderIfAbsent=true&apiKey=d09e0bc02eef4ced83b05308e83d6101"
        alt="Section divider"
        className="object-cover w-full h-auto  o mt-14 w-full h-auto max-h-auto md:max-h-auto lg:max-h-auto max-md:mt-10 "
        initial={{ scale: 0.8, opacity: 0 }}
        whileInView={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
         style={{
            Color: "#FEF7F1", // Apply the #FEF7F1 color code here
            opacity: 1, // Adjust opacity if you want more or less transparency
            }}

      />
    </motion.section>
  );
};

export default SignatureSection;
